export default {
    'packing-lists': 'Packing Lists',
    'the-packing-list': 'the packing list?',
    'add-a-packing-list': 'Add a packing list',
    to: 'To',
    'packing-list': 'packing list',
}